<div class="widget-title">% Of Cars Flexed On</div>
<div #canvasWrapper class="canvasWrapper" style="margin:auto">
        <canvas [hidden]="noDataAvailable" class="canvasWrapper" id="cars-flexed-on-pie-chart"></canvas>
</div>